import { render, staticRenderFns } from "./BWM2024ChargingDisclosureiX.vue?vue&type=template&id=250f65e4&"
import script from "./BWM2024ChargingDisclosureiX.vue?vue&type=script&lang=js&"
export * from "./BWM2024ChargingDisclosureiX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports